<rap-breadcrumb-default [exploreLabel]="'Rap Almanac'" [exploreLink]="'/dashboard/explore'"
    [exploreImage]="'../assets/images/filled.svg'" [rostersLabel]="'Cards'"
    (rostersClick)="onCards()"></rap-breadcrumb-default>

<div class="section-body">
    <rap-spinner class="loader-overlay" *ngIf="isLoading"></rap-spinner>
    <div class="section-title"> Cards </div>

    <div class="grid-container">
        <div class="grid-item" *ngFor="let item of data">
            <img [src]="item.path !== null ? item.path : 'assets/images/favicon.png'"
                [ngClass]="{'logo': item.path !== null, 'logo1': item.path === null}">
            <h3>Search word : {{ item.searchWord }}</h3>
            <div *ngIf="item.chartType === 'Bar chart'">

                <canvasjs-chart [options]="getChartOptions(item)"
                    [styles]="{ width: '70%', height:'300px',display: 'block', margin: '0 auto' }"></canvasjs-chart>


            </div>
            <div *ngIf="item.chartType === 'Timeline'">
                <canvasjs-chart [options]="getChartOptionsTimeLine(item)"
                    [styles]="{ width: '80%', height:'300px'}"></canvasjs-chart>

            </div>
            <div *ngIf="item.chartType === 'Nearest Neighbour'"
                [styles]="{ width: '70%', height:'300px', display: 'block', margin: '0 auto'}">
                <rap-word-count-chart [data]="item.data[0]" [queryWord]=""></rap-word-count-chart>
            </div>
            <p>{{ item.text | htmlToText }}</p>
            <div class="button-container">
                <rap-rect-primary [label]="'View'" [btnClass]="'btn btn-dark rect-primary-btn2'"
                    (clickEvent)="onView(item)"></rap-rect-primary>
                <rap-rect-primary [label]="'Copy Link'" [btnClass]="'btn btn-dark rect-primary-btn2'"
                    (clickEvent)="copyLink(item)"></rap-rect-primary>
                <rap-rect-primary [label]="'Edit'" [btnClass]="'btn btn-dark rect-primary-btn2'"
                    (clickEvent)="edit(item)"></rap-rect-primary>
                <rap-rect-primary [label]="'Delete'" [btnClass]="'btn btn-dark rect-primary-btn2'"
                    (clickEvent)="delte(item)"></rap-rect-primary>

            </div>
        </div>
    </div>
</div>